export const AnalyticsPageComponent = {
  Component: null as any,
};
